"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterList = exports.namePassesFilter = exports.isFilteringActive = void 0;
var _ = __importStar(require("lodash"));
var react_1 = __importDefault(require("react"));
exports.isFilteringActive = function (filterList) { return !_.isEmpty(filterList); };
exports.namePassesFilter = function (name, filterList) {
    if (!exports.isFilteringActive(filterList))
        return true;
    var nameLower = name.toLocaleLowerCase();
    return _.some(filterList, function (filterString) { return nameLower.indexOf(filterString) !== -1; });
};
function useFilterList(initial) {
    var _a = react_1.default.useState(initial), filterList = _a[0], setFilterList = _a[1];
    var onChange = function (e) {
        var inputValue = e.target.value.trim();
        if ('' === inputValue) {
            // all visible
            setFilterList([]);
        }
        else {
            // filter
            var filterList_1 = inputValue.split(",").map(function (s) { return s.trim().toLocaleLowerCase(); }).filter(function (s) { return s.length !== 0; });
            setFilterList(filterList_1);
        }
    };
    return [filterList, setFilterList, onChange];
}
exports.useFilterList = useFilterList;
